module.exports = __webpack_public_path__ + "media/IBMPlexSans-Bold.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/IBMPlexSans/IBMPlexSans-Bold.woff2
// module id = 1467
// module chunks = 58